import Vue from 'vue'
import AscDatePicker from '@/components/atoms/AscDatePicker'

export default Vue.extend({
  components: {
    AscDatePicker,
  },

  data: function () {
    return {
      currentValue: {
        dates: {
          value: '0',
          startDate: null,
          endDate: null,
        },
      },
      disabled: true,
    }
  },

  computed: {
    getCustomAttrs() {
      return this.params && this.params.dateFloatFilterConfig
        ? this.params.dateFloatFilterConfig
        : {}
    },
  },

  watch: {
    currentValue(newValue) {
      this.currentValue = newValue
      const updatedValue = `${newValue.dates.value},${newValue.dates.startDate},${newValue.dates.endDate}`
      const valueToUse = newValue.dates.value === '0' ? null : updatedValue
      this.params.parentFilterInstance(function (instance) {
        instance.onFloatingFilterChanged('dates', valueToUse)
      })
    },
  },

  beforeMount() {
    if (this.params.items) {
      this.disabled = this.params.items.length === 0
    }
  },

  methods: {
    //This is required dont remove
    onParentModelChanged() {},
  },

  template: `<asc-date-picker
  v-model="currentValue"
  :hide-options-with-id="[6]"
  :show-fixed-options="true"
  :has-icon="true"
  :disabled="disabled"
  icon-position="right"
  icon="mdi-filter"
  v-bind="getCustomAttrs"
  :attach="false"
  float-filter></asc-date-picker>`,
})
